import { DIC } from "@/const/dic";
import { validateChinese } from "@/util/validate";

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("部门名称为1-30位中文"));
  } else {
    callback();
  }
};
export const noticeTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "公告名称",
      prop: "title",
      placeholder: "请输入公告名称",
      search: true,
      type: "input",
      // overHidden: true,
      solt: true,
      span: 12,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "可见部门",
      prop: "departmentId",
      solt: true,
      formsolt: true,
    },
    {
      label: "主题图片",
      prop: "coverUrl",
      solt: true,
      formsolt: true,
    },
    {
      label: "公告内容",
      prop: "content",
      component: "AvueUeditor",
      span: 24,
      hide: true,
      options: {
        action: "/api/blade-resource/oss/endpoint/put-file",
        oss:'ali',
        props: {
          res: "data",
          url: "link",
        },
         //阿里云oss配置
         ali:null,
      },
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "更新人",
      prop: "updateBy",
      type: "input",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "是否删除",
      prop: "deleteFlag",
      type: "radio",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
      dicData: DIC.DELETE_FLAG,
    },
  ],
};
